import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core';

import HtmlContent from '../../../youwell-common/components/HtmlContent';
import { getStylesFromSettings } from '../../../youwell-common/components/taskElements/TaskElement';


const useStyles = makeStyles(theme => createStyles({
    blueBox: {
        backgroundColor: '#FFFFFF25',
        margin: theme.spacing(8, -12, 16, -20),
        padding: theme.spacing(6, 12, 6, 20),

        '& p': {
            color: theme.palette.primary.main,
        },

        '& figure.image.image-style-align-left': {
            marginRight: theme.spacing(8),
        },

        [theme.breakpoints.down('sm')]: {
            margin: theme.spacing(8, -1, 16, -1),
            padding: theme.spacing(4, 0, 8, 0),
            '& figure.image.image-style-align-left': {
                display: 'none',
            },
        },
    },
    tanBox: {
        backgroundColor: '#FFDECC76',
        margin: theme.spacing(8, -12, 16, -20),
        padding: theme.spacing(4, 12, 8, 20),

        '& figure.image figcaption': {
            background: 'transparent',
            fontWeight: theme.typography.fontWeightMedium,
        },
        [theme.breakpoints.down('sm')]: {
            margin: theme.spacing(8, -2, 16, -2),
            padding: theme.spacing(4, 0, 8, 0),
        },
    },
    flexContent: {
        display: 'flex',
        flexWrap: 'wrap',

        '& h3, & h4, & h5, & h6': {
            width: '100%',
        },
        '& figure': {
            flex: '1 1 auto',
        },
        '& img': {
            maxWidth: '100%',
            width: 140,
        },
        '& figcaption': {
            maxWidth: '100%',
        },
        [theme.breakpoints.down('sm')]: {
            '& img': {
                width: 100,
            },
        },
        [theme.breakpoints.down('xs')]: {
            display: 'block',
        },
    },
    content: {
        marginTop: theme.spacing(4),
    },
    htmlContent: {
        '& h3': {
            fontWeight: 500,
            marginBottom: theme.spacing(4),
            '&:first-child': {
                marginTop: 0,
            },
        },
        '& ul': {
            padding: theme.spacing(4),
        },
        '& li': {
            marginBottom: theme.spacing(4),
        },
        '& ul li::marker': {
            color: 'black',
            fontSize: '1em',
        },
    },
}));


const HomeContent = ({ task }) => {
    const classes = useStyles();
    if (!task) {
        return null;
    }
    const choosenHtmlContent = (element) => {
        switch (element.settings?.styleId) {
        case 'bluebox':
            return (
                <div className={classes.blueBox}>
                    <HtmlContent html={element.htmlContent} className={classes.htmlContent} style={getStylesFromSettings(element.settings)} />
                </div>
            );
        case 'tanbox':
            return (
                <div className={classes.tanBox}>
                    <HtmlContent html={element.htmlContent} className={classnames(`${classes.flexContent}`, classes.htmlContent)} style={getStylesFromSettings(element.settings)} />
                </div>

            );
        default:
            return (<HtmlContent html={element.htmlContent} className={classnames(classes.content, classes.htmlContent)} style={getStylesFromSettings(element.settings)} />
            );
        }
    };
    return (
        <>
            {task.contentElements.map(el => (
                <div key={el.id}>
                    {choosenHtmlContent(el)}
                </div>
            ))}
        </>
    );
};

HomeContent.propTypes = {
    task: PropTypes.object,
};
HomeContent.defaultProps = {
    task: null,
};

export default HomeContent;
